import { Box } from '@chakra-ui/react'
import { useEffect } from 'react'

import { Steps } from '@/components/Steps'
import { PoleasImport } from '@/containers/poleas/PoleasImport'
import { useAuth } from '@/context/AuthContext'
import { PoleasImportProvider } from '@/context/PoleasImportProvider'
import { SidebarProvider } from '@/context/SidebarContext'
import { useNavigateToUnauthorized } from '@/hooks/useCustomNavigate'
import { Sidebar } from '@/layouts/components/Sidebar'

import { WithAuth } from '../../hoc/WithAuth'
import { PageWrapper } from '../../layouts/components/PageWrapper'


const PoleasImportPageComponent = () => {
  const navigateToUnauthorized = useNavigateToUnauthorized()
  const { user } = useAuth()

  useEffect(() => {
    if (!user?.poleas?.poleasEnabled)
      navigateToUnauthorized('User does not have enabled Poleasing.')
    else if (!user?.poleas?.enableImport)
      navigateToUnauthorized('User does not have enabled Poleasing import.')
  }, [user])

  return (
    <SidebarProvider>
      <PageWrapper
        sidebar={<Sidebar />}
        steps={<Steps />}
      >
        <Box sx={{ pt: { base: 0, md: 8 } }}>
          <PoleasImportProvider>
            <PoleasImport />
          </PoleasImportProvider>
        </Box>
      </PageWrapper>
    </SidebarProvider>
  )
}

export const PoleasImportPage = WithAuth(PoleasImportPageComponent)